import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Immutable from 'immutable';

import Select from '@uncinc/uncinc-react-kitchen-sink/dist/components/Form/Select';

const WebformSelect = (props) => {
  const { entity, customClasses, type, showOther, ...fieldProps } = props;
  const { touched, errors, values, setFieldValue } = fieldProps;
  const { t } = useTranslation();
  const title = entity.get('#title');
  const required = entity.get('#required');
  const description = entity.get('#description');
  const placeholder = entity.get('#empty_option');
  const requiredError = entity.get('#required_error');
  const key = entity.get('#webform_key');
  const otherLabel = entity.get('#other__option_label');
  const otherPlaceholder = entity.get('#other__placeholder');

  let options = entity.get('#options', Immutable.Map());
  if (showOther) {
    options = options.set('__other__', 'Anders');
  }

  const validation = (value) => {
    let error;
    if (required && !value) {
      error = requiredError || t('webform_required');
    }
    return error;
  };

  useEffect(() => {
    // Set field to null by default to prevent incorrect validation.
    setFieldValue(key, null);
  }, [key, setFieldValue]);

  return (
    <div className="WebformSelect">
      <Select
        {...fieldProps}
        title={title}
        required={required}
        description={description}
        placeholder={placeholder}
        fieldName={key}
        validation={validation}
        touched={touched[key]}
        error={errors[key]}
        value={values[key]}
        options={options.toJS()}
        otherLabel={otherLabel}
        otherPlaceholder={otherPlaceholder}
      />
    </div>
  );
};

export default WebformSelect;
